import dayjs, { type Dayjs } from 'dayjs';

export const getDayStartTimestamp = (day: Dayjs) => {
  return dayjs(day).format('YYYY-MM-DD[T00:00:00][Z]');
};
